import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import ErrorReturn from '../components/contact/error_return';
import Topbar from '../components/Topbar';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language, changeLanguage } = useContext(LanguageContext);
  
    // 🚀 頁面載入就強制切換到 zh-TW
    useEffect(() => {
      changeLanguage("en"); // 👈 統一在這裡指定
    }, []);
  const LANGUAGE = componentLanguageData.ErrorReturn || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <ErrorReturn />
    </div>
  );
};

export default Page;